export default "__VITE_ASSET__BrWT0$KS__"